import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.enrolledTitleList = function (state, payload) {
  state.enrolledTitleList = {
    all: [],
    inProgress: [],
    rejected: [],
    pending: [],
    approved: []
  }
  payload.forEach(element => {
    if (element.progress_status === 1) {
      state.enrolledTitleList.inProgress.push(element)
    } else if (element.progress_status === 4) {
      state.enrolledTitleList.rejected.push(element)
    } else if (element.progress_status === 2) {
      state.enrolledTitleList.pending.push(element)
    } else if (element.progress_status === 3) {
      state.enrolledTitleList.approved.push(element)
    }
  })
  state.enrolledTitleList.all = state.enrolledTitleList.inProgress.concat(state.enrolledTitleList.rejected, state.enrolledTitleList.pending, state.enrolledTitleList.approved)
}
mutations.nowEditTitle = function (state, payload) {
  state.nowEditTitle = payload
}
mutations.getTitleQuestions = function (state, payload) {
  state.titleQuestions = payload
}
mutations.getQuestionAnswers = function (state, payload) {
  state.questionAnswers = payload
}
mutations.deleteAnswer = function (state, payload) {
  state.questionAnswers.splice(payload, 1)
}

mutations.newAnswer = function (state, payload) {
  state.questionAnswers.push(SysUtils.cloneObject(payload))
}
mutations.saveAnswer = function (state, payload) {
  state.questionAnswers[payload.index] = payload.row
}

const state = {
  rows: [],
  row: null,
  condition: {},
  enrolledTitleList: {},
  nowEditTitle: null,
  titleQuestions: [],
  questionAnswers: []
}
const actions = {
  init: ({ commit, state }, userID) => {
    const ctx = {
      data: {
        enrolledTitleList: {api: 'M0202TitleService.getTeacherEnrolledTitle', input: userID}
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('enrolledTitleList', data.enrolledTitleList.output)
      })
  },
  getTitleQuestions: ({ commit, state }, titleID) => {
    console.debug('called M0203Question search')
    return client.postData({ data: { search: { api: 'M0203QuestionService.getTitleQuestions', input: titleID } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('getTitleQuestions', data.search.output)
      })
  },
  getQuestionAnswers: ({ commit, state }, questionID) => {
    console.debug('called M0203Question getQuestionAnswers')
    return client.postData({ data: { getQuestionAnswers: { api: 'M0204AnswerService.getQuestionAnswers', input: questionID } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.getQuestionAnswers.output)) {
          alert('no match record')
        }
        commit('getQuestionAnswers', data.getQuestionAnswers.output)
      })
  },
  saveQuestionWithAnswer: ({ commit, state }, question) => {
    console.debug('called M0203Question saveQuestionWithAns')
    return client.postData({ data: { getQuestionAnswers: { api: 'M0203QuestionService.saveQuestionWithAnswer', input: question } } })
      .then((data) => {
        commit('getTitleQuestions', data.getQuestionAnswers.output)
      })
  },
  updateTitleStatus: ({ commit, state }, updateStatusDetail) => {
    console.debug('called M0203Question save')
    return client.postData({ data: { save: { api: 'M0202TitleService.updateTitleStatus', input: updateStatusDetail } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0203Question/M0203QuestionStore.js